<template>
<div class="popup_overlay">
  <div class="custom_dialog_comp bg-white h-full" style="width:100%">
    <div class="cust_card_comp">
      <div class=" rounded px-5 py-4 h-full bg-primary text-white heading-2 font-bold flex items-center justify-between">
        <div>
          <p class="">single_image</p>
        </div>
        <div>
          <button class="list_top_card_btn font-bold bg-gray-200 cta-text text-text1 py-2 px-4 mr-2 rounded-3xl" @click="closeDetails(false)">Discard</button>
          <button class="list_top_card_btn font-bold  bg-success cta-text text-white py-2 px-4 rounded-3xl" @click="saveData()">Save</button>
        </div>  
      </div>
  <div class="p-0 bg-white" >
    <div class="bg-white p-2">
      <div class="pt-2 px-1 grid grid-cols-2 gap-x-2">
        <div class="box bg-white h-full cust_card">
          <div>
            <div class="p-2 pb-10 grid grid-cols-12">
              <div class="box col-span-12 p-2 pb-0">
                <p class="label_css">heading</p>
                <textarea v-model="fieldJsonData.heading"
                class="outline-none  text-gray-900 text-sm rounded  block w-full pl-2 p-2.5 h-12 heading-4 border border-gray-500 focus:border-gray-800" 
                placeholder="heading"
                ></textarea>
              </div>
              <div v-if="topDescriptionEditor === false" class="box col-span-12 p-2 pb-0" :class="componentDetailsForEdit !== null ? '' : 'mt-4'">
                <p class="label_css font-bold cursor-pointer" style="color: #1976D3" @click="openTopDescription()">{{componentDetailsForEdit !== null ? "+ Edit Top Description" : "+ Add Top Description"}}</p>
                <p v-if="componentDetailsForEdit !== null" v-html="fieldJsonData.top_description"></p>
              </div>
              <div v-if="topDescriptionEditor" class="box col-span-12 p-2 pb-0" v-click-outside="closeTopDescription">
                <p class="label_css">top_description</p>
                <editor v-model="fieldJsonData.top_description"
                placeholder="top_description"
                ></editor>
              </div>
              <div class="box col-span-6 p-2 pb-0">
                <p class="label_css">img_url</p>
                <input v-model="fieldJsonData.img_url"
                :class="img_url_err ? 'border border-error' : ''"
                class="outline-none  text-gray-900 text-sm rounded  block w-full pl-2 p-2.5 h-12 heading-4 border border-gray-500 focus:border-gray-800" 
                placeholder="img_url"
                >
                <p v-if="img_url_err" class="text-error heading-6">img_url is required</p>
              </div>
              <div class="box col-span-6 p-2 pb-0">
                <p class="label_css">img_alt</p>
                <input v-model="fieldJsonData.img_alt"
                :class="img_alt_err ? 'border border-error' : ''"
                class="outline-none  text-gray-900 text-sm rounded  block w-full pl-2 p-2.5 h-12 heading-4 border border-gray-500 focus:border-gray-800" 
                placeholder="img_alt"
                >
                <p v-if="img_alt_err" class="text-error heading-6">img_alt is required</p>
              </div>
              <div v-if="descriptionEditor === false" class="box col-span-12 p-2 pb-0" :class="componentDetailsForEdit !== null ? '' : 'mt-4'">
                <p class="label_css font-bold cursor-pointer" style="color: #1976D3" @click="openDescription()">{{componentDetailsForEdit !== null ? "+ Edit Bottom Description" : "+ Add Bottom Description"}}</p>
                <p v-if="componentDetailsForEdit !== null" v-html="fieldJsonData.description"></p>
              </div>
              <div v-if="descriptionEditor" class="box col-span-12 p-2 pb-0" v-click-outside="closeDescription">
                <p class="label_css">bottom_description</p>
                <editor v-model="fieldJsonData.description"
                placeholder="bottom_description"
                ></editor>
              </div>
            </div>
          </div>
          <!-- <div class="p-2 pb-5 text-right">
            <div>
              <button class="list_top_card_btn bg-gray-200 cta-text text-text1 py-2 px-4 mr-2 rounded-3xl">Discard</button>
              <button class="list_top_card_btn bg-primary cta-text text-white py-2 px-4 mr-2 rounded-3xl" @click="saveData()">Save</button>
            </div>  
          </div> -->
        </div>
        <div>
        <img style="padding: 1px"  class="box border-1 shadow-lg rounded-lg" :src="componentImageUrl" :alt="componentImageUrl" />
      </div>
      </div>
    </div>
  </div>
    </div>
  </div>
</div>
</template>
<script>
import Editor from '../../../../../../components/editor.vue'
// import draggable from 'vuedraggable'
// import HRM from '@/View/CMS/api/HRM.js'
export default {
  components: {
    Editor
    // draggable,
  },
  props: ['componentDetailsForEdit', 'fieldJsonData', 'componentImageUrl', 'componentId'],
  data () {
    return {
      topDescriptionEditor: false,
      descriptionEditor: false,
      img_alt_err: false,
      img_url_err: false,
      heading_err: false,
      isError: true,
      // fieldJsonData: {
      //   component_name: "fieldJsonData",
      //   heading: "",
      //   img_url: "",
      //   img_alt: "",
      //   description: "",
      //   cta_in_new_tab: false
      // }
    }
  },
  created() {
    if (this.componentDetailsForEdit !== null) {
      console.log("componentDetailsForEdit!!!!!!!!!!!HeadWithButton", this.componentDetailsForEdit)
      this.fieldJsonData = this.componentDetailsForEdit
      console.log("this.fieldJsonData", this.fieldJsonData)
    }
  },
  mounted () {
    console.log("fieldJsonData", this.fieldJsonData)
  },
  watch: {
    fieldJsonData: {
      handler () {
        console.log('fieldJsonData 123', this.fieldJsonData)
        if (this.fieldJsonData.img_alt !== '') {
          this.img_alt_err = false
          this.isError = false
        }
        if (this.fieldJsonData.img_url !== '') {
          this.img_url_err = false
          this.isError = false
        }
      },
      deep: true
    }
  },
  methods: {
    openDescription () {
      this.topDescriptionEditor = false
      this.descriptionEditor = true
    },
    closeDescription () {
      this.descriptionEditor = false
    },
    openTopDescription () {
      this.descriptionEditor = false
      this.topDescriptionEditor = true
    },
    closeTopDescription () {
      this.topDescriptionEditor = false
    },
    saveData() {
      if (this.fieldJsonData.img_alt === '') {
        this.img_alt_err = true
        this.isError = true
      }
      if (this.fieldJsonData.img_url === '') {
        this.img_url_err = true
        this.isError = true
      }
      if (this.isError === false) {
        this.$emit('objData', this.fieldJsonData)
        this.componentDetailsForEdit = null
        let compIdImage = {
          imageUrl: this.componentImageUrl,
          id: this.componentId
        }
        // this.$emit('imageData', this.componentImageUrl)
        this.$emit('compIdImage', compIdImage)
        this.$root.$emit('closeComponentDialog', true)
        console.log("this.fieldJsonData............", this.fieldJsonData)
      }
    },
    closeDetails () {
    this.$root.$emit('closeComponentDialog', true)
    },
  },
  beforeDestroy () {
  }
}
</script>
<style scoped>
/* .list_top_card_btn {
  width: 163px !important;
  margin-right: 15px !important;
} */

::placeholder {
  font-size: 16px;
}
</style>